import React from "react";
import { useHistory } from "react-router-dom";
import Dialog from "../../../components/Dialog";
import DialogStyles from "../../../styles/components/DialogStyles";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import HeaderMyPanel from "./components/HeaderInformation";

const { StyledContainerButton, StyledTable, StyledTableHead } = DialogStyles;

const { BtnPrimary, BtnOutlinePrimary } = ButtonStyles;

const columnKeyMap: { [key: string]: string } = {
    Atividade: "atividade",
    Curso: "curso",
    "Tipo de Cartão": "tipoCartao",
    "Tipo de Atividade": "tipoAtividade",
    "CH (hora/aula)": "cargaHoraria",
    "Motivo justificativa": "motivoJustificativa",
    "Data de alocação": "dataAlocacao",
    "Período de referência": "__periodoReferenciaCustom",
    "Docente substituto": "docenteSubstituto",
    Status: "statusCheckin",
    "Ação do Docente": "",
    "Cartão vinculado Atividade original": "cartaoVinculadoAtividadeOriginal",
    "Docente substituído": "docenteSubstituto",
};

const formatDateToDDMMYYYY = (dateString: string | undefined): string => {
    if (!dateString) return "-";
    const parts = dateString.split("-");
    if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateString;
};

interface MyPanelModalProps {
    open: boolean;
    onClose: () => void;
    text?: string;
    title: string;
    subtitle?: string;
    warning?: string;
    columns: string[];
    rows: { [key: string]: string }[];
    showOkButton?: boolean;
}

const MyPanelModal = ({
    open,
    onClose,
    text,
    title,
    subtitle,
    warning,
    columns,
    rows,
    showOkButton = true,
}: MyPanelModalProps) => {
    const history = useHistory();
    const handleAcessarAgenda = (dataAlocacao: string | undefined) => {
        if (!dataAlocacao) return;

        let dataFormatada: string;
        const delimitador = dataAlocacao.includes("/") ? "/" : "-";
        const partes = dataAlocacao.split(delimitador);

        /* eslint-disable prefer-destructuring */
        if (partes.length === 3) {
            const dia = partes[0];
            const mes = partes[1];
            const ano = partes[2];
            dataFormatada = `${ano}-${mes}-${dia}`;
        } else {
            const date = new Date(dataAlocacao);
            if (Number.isNaN(date.getTime())) return;
            dataFormatada = date.toISOString().split("T")[0];
        }
        /* eslint-enable prefer-destructuring */

        const dateObj = new Date(
            `${partes[2]}-${partes[1]}-${partes[0]}T00:00:00.000-03:00`
        );

        if (dateObj.getDay() === 1) {
            dateObj.setDate(dateObj.getDate() + 1);
        }

        const dataNovaFormatada = dateObj.toISOString().split("T")[0];

        history.push(`/minha-agenda?date=${dataNovaFormatada}`);
    };

    const generateUniqueKey = (): string => {
        const randomPart = Math.floor(Math.random() * 1000000);
        const timestamp = Date.now();
        return `${timestamp}-${randomPart}`;
    };

    const formatDecimal = (value: string | undefined): string => {
        if (!value || value === "-") return "-";
        return value.replace(".", ",");
    };

    return (
        <Dialog openModal={open} onHide={onClose} size="xl">
            <HeaderMyPanel
                text={text}
                title={title}
                subtitle={subtitle}
                warning={warning}
            />

            <div
                style={{
                    overflowX: "auto",
                    overflowY: rows.length >= 10 ? "auto" : "visible",
                    maxHeight: "798px",
                    marginTop: "12px",
                }}
            >
                <StyledTable style={{ minWidth: "900px", maxWidth: "100%" }}>
                    <StyledTableHead>
                        <tr>
                            {columns.map((col) => (
                                <th key={col}>{col}</th>
                            ))}
                        </tr>
                    </StyledTableHead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={generateUniqueKey()}>
                                {columns.map((col) => {
                                    const key = columnKeyMap[col] ?? "";
                                    let value = row[key] ?? "-";

                                    if (key === "cargaHoraria") {
                                        value = formatDecimal(row[key]);
                                    }

                                    if (key === "dataAlocacao") {
                                        value = formatDateToDDMMYYYY(row[key]);
                                    }

                                    if (key === "__periodoReferenciaCustom") {
                                        const inicio = formatDateToDDMMYYYY(
                                            row.periodoReferenciaInicio
                                        );
                                        const fim = formatDateToDDMMYYYY(
                                            row.periodoReferenciaFim
                                        );
                                        if (fim !== "-") {
                                            value = `${inicio} a ${fim}`;
                                        } else {
                                            value = `${inicio}`;
                                        }
                                    }

                                    return (
                                        <td
                                            style={{
                                                color: "#404040",
                                                textAlign: "center",
                                            }}
                                            key={col}
                                        >
                                            {col === "Ação do Docente" ? (
                                                <BtnOutlinePrimary
                                                    onClick={() =>
                                                        handleAcessarAgenda(
                                                            row.dataAlocacao
                                                        )
                                                    }
                                                >
                                                    Acessar Agenda
                                                </BtnOutlinePrimary>
                                            ) : (
                                                value
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </StyledTable>
            </div>

            {showOkButton && (
                <StyledContainerButton>
                    <BtnPrimary onClick={onClose}>Ok</BtnPrimary>
                </StyledContainerButton>
            )}
        </Dialog>
    );
};

export default MyPanelModal;
